<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Modification du code OAG</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="code"><strong>Code OAG : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="code" v-model="code" :class="{hasError: errors.code !== ''}" disabled></b-form-input>
                <span class='field-error'>{{ errors.code }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelleTechnique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelleTechnique" v-model="libelleTechnique" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="structure"><strong>Structure : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-select id="structure" v-model="selectedStructure" :options="structuresOptions" :class="{hasError: errors.structure !== ''}"></b-form-select>
                <span class='field-error'>{{ errors.structure }}</span>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Annuler
            </b-button>
            <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md='6'>
        <b-card style="height: 560px; overflow-y: hidden;">
          <h4>Liste des profils pour rattachement à l'OAG</h4>
          <VuePerfectScrollbar class="scroll-area-oap-oag" :settings="psSettings" @ps-scroll-y="scrollHandle">
            <b-form-checkbox
              class="mb-2 ml-1"
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            >Tous sélectionner
            </b-form-checkbox>
            <b-form-group
              v-slot="{ ariaDescribedby }" 
            >
              <b-form-checkbox v-for="profil in allProfil"
                class="ml-1"
                v-model="selectedProfils"
                :value="profil.id"
                :aria-describedby="ariaDescribedby"
                name="profils"
                :key="profil.id"
                stacked
              >{{ profil.libelle }}</b-form-checkbox>
            </b-form-group>
          </VuePerfectScrollbar>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty, permittedImageExtension} from "@/utils/fileHelper";
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: "Edit",
    components: {
      VuePerfectScrollbar
    },
    data() {
      return {
        code: '',
        libelle: '',
        selectedStructure: '',
        allStructures: [],
        allProfil: [],
        selectedProfils: [],
        structuresOptions: [],
        allSelected: [],
        indeterminate: false,
        editor: ClassicEditor,
        editorConfig: {
          allowedContent: true,
          toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'],
          language: 'fr'
        },
        errors: {
          code: '',
          libelle: '',
          structure: '',
        },
      }
    },
    async mounted() {
      this.getProfiles();
      await this.getStructures();
      await this.getOag();
      // this.code = this.$route.params.code;
    },
    watch: {
      selectedProfils(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.allProfil.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
    },
    computed: {
      psSettings: () => {
        // ToDo: find better rtl fix
        return {
          maxScrollbarLength: 200,
          minScrollbarLength: 40,
          suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
          wheelPropagation: false,
          interceptRailY: styles => ({ ...styles, height: 0 })
        }
      }
    },
    methods: {
      scrollHandle (evt) {
        // console.log(evt)
      },
      async getOag() {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        await this.$axios
          .get("/administration/oag/" + this.$route.params.id)
          .then(response => {
            this.libelle = response.data.oag.libelle;
            this.libelleTechnique = response.data.oag.libelle_technique;
            this.code = response.data.oag.code;
            this.selectedStructure = response.data.oag.structure_id;
            this.$store.commit('IS_LOADING', false);

            for (let profil of response.data.oag.profils) {
              this.selectedProfils.push(profil.id);
            }
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            self.handleError(error);
          });
      },
      async getStructures() {
        await this.$axios
          .get("/administration/structures")
          .then(response => {
            this.allStructures = response.data.structures;
            for(let structures of response.data.structures){
              this.structuresOptions.push({value: structures.id, text: structures.libelle});
            }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      getProfiles() {
        this.$axios
          .get("/administration/profiles")
          .then(response => {
            this.allProfil = response.data.profils;
            // for(let profile of response.data.profiles){
            //   this.structuresOptions.push({value: structures.id, text: structures.libelle});
            // }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      toggleAll(checked) {
        this.selectedProfils = checked ? this.allProfil.map(item => {
          return item.id
        }) : []
      },
      edit() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let code = this.code;
          let formData = new FormData();
          formData.append('code', this.code);
          formData.append('libelle', this.libelle);
          formData.append('libelleTechnique', this.libelleTechnique);
          formData.append('structure_id', this.selectedStructure);
          formData.append('profilIds', this.selectedProfils);

          this.$axios
            .post('/administration/oag/'+this.$route.params.id, formData)
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Modification avec succès',
                text: 'Le code OAG ' + code + ' a bien été modifié',
                showConfirmButton: false,
                timer: 5000
              });
              this.clearFields();
              this.returnBack();
            })
            .catch((error) => {
              self.$store.commit('IS_LOADING', false);
              self.handleError(error);
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/administration/gestionOapOag/oag/list'});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.code.trim() === '') {
          this.errors.code = 'Le code est obligatoire';
          valid = false;
        }
        if (isEmpty(this.libelle) || (!isEmpty(this.libelle) && this.libelle.trim() === '')) {
          this.errors.libelle = 'Le libellé est obligatoire';
          valid = false;
        }
        if (this.selectedStructure === '') {
          this.errors.structure = 'Le choix d\'une structure est obligatoire';
          valid = false;
        }

        return valid;
      },
      clearErrors() {
        this.errors.code= '';
        this.errors.libelle = '';
        this.errors.structure = '';
      },
      clearFields() {
        this.code = '';
        this.selectedStructure = '';
        this.libelle = '';
      },
      handleError(error) {
        console.log(error)
        
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit de gérer cet OAG';
        } else if (!isEmpty(error) && error.response && (error.response.status === 406 || error.response.status === 424)) {
          text = error.response.data.message;
        } else if (error.response && error.response.status === 404 && this != undefined) {
          this.$router.push({path: '/administration/gestionOapOag/oag'})
          text: 'L\'OAG avec l\'id ' + this.$route.params.id + ' n\'existe pas';
        }
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: text,
          showConfirmButton: false,
          timer: 5000
        });
      },
    }
  }
</script>
<style type="text/css">
  .scroll-area-oap-oag {
    position: absolute;
    height: 88%;
    width: 90%;
  }
</style>
